export const PUBLIC_URL = process.env.NEXT_PUBLIC_API_URL;
